// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.pc-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding: 24px 0 60px;
}

.pc-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
@media (max-width: 767px) {
  .pc-container {
    padding: 0 16px;
  }
}

.pc-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  margin: 16px 0 0;
}
.pc-breadcrumb a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s;
}
.pc-breadcrumb a:hover {
  color: rgb(105, 190, 40);
}
.pc-breadcrumb__sep {
  color: #ccc;
}
.pc-breadcrumb__current {
  color: #676a6c;
  font-weight: 600;
}

.pc-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 24px;
}
.pc-header__title {
  font-size: 24px;
  font-weight: 700;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
.pc-header__title i {
  color: #ccc;
  margin-right: 4px;
}
.pc-header__count {
  font-size: 13px;
  font-weight: 600;
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.08);
  padding: 3px 10px;
  border-radius: 10px;
}

.pc-layout {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: start;
}
@media (max-width: 991px) {
  .pc-layout {
    grid-template-columns: 1fr;
  }
}
.pc-layout__main {
  min-width: 0;
}
.pc-layout__sidebar {
  min-width: 0;
}

.pc-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  overflow: hidden;
}

.pc-item {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #e7eaec;
  align-items: flex-start;
}
.pc-item:last-child {
  border-bottom: none;
}
@media (max-width: 640px) {
  .pc-item {
    flex-wrap: wrap;
  }
}
.pc-item__image {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
  flex-shrink: 0;
  border: 1px solid #e7eaec;
}
.pc-item__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}
.pc-item__image--gift {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(105, 190, 40, 0.05);
  border-color: rgba(105, 190, 40, 0.15);
  color: rgb(105, 190, 40);
  font-size: 22px;
}
.pc-item__body {
  flex: 1;
  min-width: 0;
}
.pc-item__name {
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
  margin: 0 0 6px;
  cursor: pointer;
  line-height: 1.3;
  transition: color 0.15s;
}
.pc-item__name:hover {
  color: rgb(0, 173, 208);
}
.pc-item__name--comp {
  color: #ccc;
  cursor: pointer;
}
.pc-item__comp-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  margin-left: 6px;
  vertical-align: middle;
  text-transform: uppercase;
}
.pc-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-bottom: 8px;
}
.pc-item__meta span {
  font-size: 12px;
  color: #676a6c;
}
.pc-item__meta span i {
  font-size: 10px;
  color: #ccc;
  margin-right: 3px;
  width: 12px;
  text-align: center;
}
.pc-item__meta--promo {
  color: rgb(105, 190, 40) !important;
}
.pc-item__meta--promo i {
  color: rgb(105, 190, 40) !important;
}
.pc-item__remove {
  border: none;
  background: none;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
  padding: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: color 0.15s;
}
.pc-item__remove:hover {
  color: rgb(245, 67, 89);
}
.pc-item__remove i {
  margin-right: 3px;
}
.pc-item__pricing {
  display: flex;
  gap: 20px;
  flex-shrink: 0;
  align-items: flex-start;
}
@media (max-width: 640px) {
  .pc-item__pricing {
    width: 100%;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px dashed #e7eaec;
  }
}
.pc-item__price-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}
.pc-item__price-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #ccc;
  margin-bottom: 4px;
}
.pc-item__price-value {
  font-size: 14px;
  font-weight: 500;
  color: #676a6c;
}
.pc-item__qty-input {
  width: 52px;
  height: 32px;
  border: 1px solid #e7eaec;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  outline: none;
  transition: border-color 0.2s;
}
.pc-item__qty-input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.1);
}
.pc-item__qty-fixed {
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
}
.pc-item__total {
  font-size: 15px;
  font-weight: 700;
  color: #676a6c;
}

.pc-actions {
  margin-top: 12px;
}

.pc-empty {
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
}
.pc-empty__icon {
  font-size: 40px;
  color: #ccc;
  margin-bottom: 12px;
  opacity: 0.4;
}
.pc-empty__title {
  font-size: 18px;
  font-weight: 700;
  color: #676a6c;
  margin: 0 0 4px;
}
.pc-empty__text {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 20px;
}

.pc-summary {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: 20px;
}
.pc-summary__header {
  padding: 14px 20px;
  background: #6d6e71;
  border-bottom: 1px solid #e7eaec;
}
.pc-summary__header h3 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.pc-summary__header h3 i {
  margin-right: 6px;
  opacity: 0.7;
}
.pc-summary__body {
  padding: 16px 20px;
}
.pc-summary__item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  gap: 12px;
}
.pc-summary__item-info {
  flex: 1;
  min-width: 0;
}
.pc-summary__item-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  line-height: 1.3;
  margin-bottom: 2px;
}
.pc-summary__item-qty {
  font-size: 11px;
  color: #ccc;
}
.pc-summary__item-price {
  font-size: 13px;
  font-weight: 600;
  color: #676a6c;
  white-space: nowrap;
}
.pc-summary__divider {
  height: 1px;
  background: #e7eaec;
  margin: 8px 0;
}
.pc-summary__row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 13px;
  color: #676a6c;
}
.pc-summary__row--muted {
  font-size: 12px;
  color: #ccc;
}
.pc-summary__row--total {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
  padding-top: 8px;
}
.pc-summary__amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.pc-summary__amount--total {
  font-size: 18px;
  color: rgb(105, 190, 40);
}
.pc-summary__amount--muted {
  font-weight: 400;
  font-size: 11px;
  color: #ccc;
  font-style: italic;
}
.pc-summary__footer {
  padding: 16px 20px;
  border-top: 1px solid #e7eaec;
  text-align: center;
}
.pc-summary__or {
  font-size: 12px;
  color: #ccc;
  margin: 8px 0;
}

.pc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.pc-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  box-shadow: 0 2px 6px rgba(105, 190, 40, 0.2);
}
.pc-btn--primary:hover {
  background: #5ba523;
  box-shadow: 0 4px 12px rgba(105, 190, 40, 0.3);
  color: #fff;
  text-decoration: none;
}
.pc-btn--outline-red {
  background: none;
  border: 1px solid #e7eaec;
  color: #ccc;
  font-size: 12px;
  padding: 7px 14px;
}
.pc-btn--outline-red:hover {
  border-color: rgb(245, 67, 89);
  color: rgb(245, 67, 89);
}
.pc-btn--link {
  background: none;
  color: rgb(0, 173, 208);
  font-size: 13px;
}
.pc-btn--link:hover {
  color: #00839d;
  text-decoration: none;
}
.pc-btn--full {
  width: 100%;
  padding: 12px;
  font-size: 15px;
}

.coupon-banner {
  margin-bottom: 16px;
}
.coupon-banner__inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgba(105, 190, 40, 0.06), rgba(105, 190, 40, 0.02));
  border: 1px solid rgba(105, 190, 40, 0.2);
  border-radius: 8px;
}
.coupon-banner__icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(105, 190, 40, 0.12);
  color: rgb(105, 190, 40);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.coupon-banner__text {
  flex: 1;
  font-size: 13px;
  color: #676a6c;
  line-height: 1.4;
}
.coupon-banner__text strong {
  display: block;
  font-size: 14px;
  margin-bottom: 2px;
}
.coupon-banner__code {
  display: inline-block;
  padding: 1px 8px;
  background: #fff;
  border: 1px dashed rgba(105, 190, 40, 0.4);
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  font-weight: 700;
  color: rgb(105, 190, 40);
  letter-spacing: 0.5px;
}
.coupon-banner__close {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #ccc;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
}
.coupon-banner__close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #676a6c;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-store-cart/public-store-cart.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;AA+YF;;AA5YA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AA+YF;AA7YE;EALF;IAK8B,eAAA;EAiZ5B;AACF;;AA9YA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,wEDtBW;ECuBX,cDYmB;ECXnB,gBAAA;AAiZF;AA/YE;EACE,cDQiB;ECPjB,qBAAA;EACA,uBAAA;AAiZJ;AA/YI;EAAU,wBDRE;AC0ZhB;AA/YE;EAAS,WDQS;AC0YpB;AAhZE;EACE,cDFiB;ECGjB,gBAAA;AAkZJ;;AA7YA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAgZF;AA9YE;EACE,eAAA;EACA,gBAAA;EACA,cDjBiB;ECkBjB,wEDrDS;ECsDT,SAAA;AAgZJ;AA9YI;EAAI,WDdY;ECce,iBAAA;AAkZnC;AA/YE;EACE,eAAA;EACA,gBAAA;EACA,wBDvCY;ECwCZ,oCAAA;EACA,iBAAA;EACA,mBAAA;AAiZJ;;AA5YA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AA+YF;AA7YE;EANF;IAOI,0BAAA;EAgZF;AACF;AA9YE;EAAU,YAAA;AAiZZ;AAhZE;EAAa,YAAA;AAmZf;;AA/YA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAkZF;;AA9YA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,uBAAA;AAiZF;AA/YE;EAAe,mBAAA;AAkZjB;AAhZE;EATF;IAUI,eAAA;EAmZF;AACF;AAhZE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAkZJ;AAhZI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAkZN;AA/YI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,wBD1GU;EC2GV,eAAA;AAiZN;AA5YE;EACE,OAAA;EACA,YAAA;AA8YJ;AA3YE;EACE,eAAA;EACA,gBAAA;EACA,cD5GiB;EC6GjB,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AA6YJ;AA3YI;EAAU,uBDhIE;AC8gBhB;AA5YI;EACE,WD9Gc;EC+Gd,eAAA;AA8YN;AA1YE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBD7IY;EC8IZ,gBAAA;EACA,sBAAA;EACA,yBAAA;AA4YJ;AAxYE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA0YJ;AAxYI;EACE,eAAA;EACA,cDhJe;AC0hBrB;AAxYM;EACE,eAAA;EACA,WD7IY;EC8IZ,iBAAA;EACA,WAAA;EACA,kBAAA;AA0YR;AAtYI;EACE,mCAAA;AAwYN;AAvYM;EAAI,mCAAA;AA0YV;AArYE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WD/JgB;ECgKhB,eAAA;EACA,UAAA;EACA,wED5MS;EC6MT,uBAAA;AAuYJ;AArYI;EAAU,uBDvLI;AC+jBlB;AAtYI;EAAI,iBAAA;AAyYR;AArYE;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;AAuYJ;AArYI;EANF;IAOI,WAAA;IACA,8BAAA;IACA,gBAAA;IACA,8BAAA;EAwYJ;AACF;AArYE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAuYJ;AApYE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WDrMgB;ECsMhB,kBAAA;AAsYJ;AAnYE;EACE,eAAA;EACA,gBAAA;EACA,cDnNiB;ACwlBrB;AAlYE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cD7NiB;EC8NjB,wEDjQS;ECkQT,aAAA;EACA,6BAAA;AAoYJ;AAlYI;EACE,+BD/OU;ECgPV,6CAAA;AAoYN;AAhYE;EACE,eAAA;EACA,gBAAA;EACA,WDpOgB;ACsmBpB;AA/XE;EACE,eAAA;EACA,gBAAA;EACA,cDjPiB;ACknBrB;;AA5XA;EACE,gBAAA;AA+XF;;AA3XA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AA8XF;AA5XE;EACE,eAAA;EACA,WD7PgB;EC8PhB,mBAAA;EACA,YAAA;AA8XJ;AA3XE;EACE,eAAA;EACA,gBAAA;EACA,cD5QiB;EC6QjB,eAAA;AA6XJ;AA1XE;EACE,eAAA;EACA,WD3QgB;EC4QhB,gBAAA;AA4XJ;;AAvXA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA0XF;AAxXE;EACE,kBAAA;EACA,mBD7RiB;EC8RjB,gCAAA;AA0XJ;AAxXI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,wED7UO;ACusBb;AAxXM;EAAI,iBAAA;EAAmB,YAAA;AA4X7B;AAxXE;EACE,kBAAA;AA0XJ;AAvXE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;AAyXJ;AAtXE;EACE,OAAA;EACA,YAAA;AAwXJ;AArXE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrUiB;ECsUjB,gBAAA;EACA,kBAAA;AAuXJ;AApXE;EACE,eAAA;EACA,WDrUgB;AC2rBpB;AAnXE;EACE,eAAA;EACA,gBAAA;EACA,cDlViB;ECmVjB,mBAAA;AAqXJ;AAlXE;EACE,WAAA;EACA,mBD1UW;EC2UX,aAAA;AAoXJ;AAjXE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,cDjWiB;ACotBrB;AAjXI;EACE,eAAA;EACA,WD9Vc;ACitBpB;AAhXI;EACE,eAAA;EACA,gBAAA;EACA,cD3We;EC4Wf,gBAAA;AAkXN;AA9WE;EACE,gBAAA;EACA,kCAAA;AAgXJ;AA9WI;EACE,eAAA;EACA,wBDlYU;ACkvBhB;AA7WI;EACE,gBAAA;EACA,eAAA;EACA,WDrXc;ECsXd,kBAAA;AA+WN;AA3WE;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;AA6WJ;AA1WE;EACE,eAAA;EACA,WDlYgB;ECmYhB,aAAA;AA4WJ;;AAvWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED1bW;EC2bX,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AA0WF;AAxWE;EACE,6BD5aY;EC6aZ,WAAA;EACA,6CAAA;AA0WJ;AAxWI;EACE,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,qBAAA;AA0WN;AAtWE;EACE,gBAAA;EACA,yBAAA;EACA,WDxagB;ECyahB,eAAA;EACA,iBAAA;AAwWJ;AAtWI;EACE,8BD/bY;ECgcZ,uBDhcY;ACwyBlB;AApWE;EACE,gBAAA;EACA,uBDzcY;EC0cZ,eAAA;AAsWJ;AApWI;EACE,cAAA;EACA,qBAAA;AAsWN;AAlWE;EACE,WAAA;EACA,aAAA;EACA,eAAA;AAoWJ;;AA/VA;EACE,mBAAA;AAkWF;AAhWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uFAAA;EACA,yCAAA;EACA,kBAAA;AAkWJ;AA/VE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBD1eY;EC2eZ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAiWJ;AA9VE;EACE,OAAA;EACA,eAAA;EACA,cDzeiB;EC0ejB,gBAAA;AAgWJ;AA9VI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAgWN;AA5VE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBDxgBY;ECygBZ,qBAAA;AA8VJ;AA3VE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,WD9fgB;EC+fhB,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;AA6VJ;AA3VI;EACE,+BAAA;EACA,cDjhBe;AC82BrB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n// ── Page ──\n.pc-page {\n  min-height: 100vh;\n  background: #f7f8fa;\n  padding: 24px 0 60px;\n}\n\n.pc-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 24px;\n\n  @media (max-width: 767px) { padding: 0 16px; }\n}\n\n// ── Breadcrumb ──\n.pc-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  margin: 16px 0 0;\n\n  a {\n    color: $body-content-color;\n    text-decoration: none;\n    transition: color 0.15s;\n\n    &:hover { color: $develop-color; }\n  }\n\n  &__sep { color: $color-neutral-mid; }\n\n  &__current {\n    color: $body-content-color;\n    font-weight: 600;\n  }\n}\n\n// ── Header ──\n.pc-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0 24px;\n\n  &__title {\n    font-size: 24px;\n    font-weight: 700;\n    color: $body-content-color;\n    font-family: $font-stack;\n    margin: 0;\n\n    i { color: $color-neutral-mid; margin-right: 4px; }\n  }\n\n  &__count {\n    font-size: 13px;\n    font-weight: 600;\n    color: $develop-color;\n    background: rgba($develop-color, 0.08);\n    padding: 3px 10px;\n    border-radius: 10px;\n  }\n}\n\n// ── Layout ──\n.pc-layout {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 24px;\n  align-items: start;\n\n  @media (max-width: 991px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__main { min-width: 0; }\n  &__sidebar { min-width: 0; }\n}\n\n// ── Card Container ──\n.pc-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n// ── Cart Item ──\n.pc-item {\n  display: flex;\n  gap: 16px;\n  padding: 16px 20px;\n  border-bottom: 1px solid $color-grey-1;\n  align-items: flex-start;\n\n  &:last-child { border-bottom: none; }\n\n  @media (max-width: 640px) {\n    flex-wrap: wrap;\n  }\n\n  // Image\n  &__image {\n    width: 72px;\n    height: 72px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8f9fa;\n    flex-shrink: 0;\n    border: 1px solid $color-grey-1;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      padding: 4px;\n    }\n\n    &--gift {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba($develop-color, 0.05);\n      border-color: rgba($develop-color, 0.15);\n      color: $develop-color;\n      font-size: 22px;\n    }\n  }\n\n  // Body\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 600;\n    color: $body-content-color;\n    margin: 0 0 6px;\n    cursor: pointer;\n    line-height: 1.3;\n    transition: color 0.15s;\n\n    &:hover { color: $clarify-color; }\n\n    &--comp {\n      color: $color-neutral-mid;\n      cursor: pointer;\n    }\n  }\n\n  &__comp-badge {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 3px;\n    background: rgba($develop-color, 0.08);\n    color: $develop-color;\n    margin-left: 6px;\n    vertical-align: middle;\n    text-transform: uppercase;\n  }\n\n  // Meta details\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px 14px;\n    margin-bottom: 8px;\n\n    span {\n      font-size: 12px;\n      color: $body-content-color;\n\n      i {\n        font-size: 10px;\n        color: $color-neutral-mid;\n        margin-right: 3px;\n        width: 12px;\n        text-align: center;\n      }\n    }\n\n    &--promo {\n      color: $develop-color !important;\n      i { color: $develop-color !important; }\n    }\n  }\n\n  // Remove button\n  &__remove {\n    border: none;\n    background: none;\n    font-size: 12px;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    padding: 0;\n    font-family: $font-stack;\n    transition: color 0.15s;\n\n    &:hover { color: $implement-color; }\n\n    i { margin-right: 3px; }\n  }\n\n  // Pricing columns\n  &__pricing {\n    display: flex;\n    gap: 20px;\n    flex-shrink: 0;\n    align-items: flex-start;\n\n    @media (max-width: 640px) {\n      width: 100%;\n      justify-content: space-between;\n      padding-top: 8px;\n      border-top: 1px dashed $color-grey-1;\n    }\n  }\n\n  &__price-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 60px;\n  }\n\n  &__price-label {\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $color-neutral-mid;\n    margin-bottom: 4px;\n  }\n\n  &__price-value {\n    font-size: 14px;\n    font-weight: 500;\n    color: $body-content-color;\n  }\n\n  &__qty-input {\n    width: 52px;\n    height: 32px;\n    border: 1px solid $color-grey-1;\n    border-radius: 5px;\n    text-align: center;\n    font-size: 14px;\n    color: $body-content-color;\n    font-family: $font-stack;\n    outline: none;\n    transition: border-color 0.2s;\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba($develop-color, 0.1);\n    }\n  }\n\n  &__qty-fixed {\n    font-size: 14px;\n    font-weight: 500;\n    color: $color-neutral-mid;\n  }\n\n  &__total {\n    font-size: 15px;\n    font-weight: 700;\n    color: $body-content-color;\n  }\n}\n\n// ── Actions ──\n.pc-actions {\n  margin-top: 12px;\n}\n\n// ── Empty State ──\n.pc-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n\n  &__icon {\n    font-size: 40px;\n    color: $color-neutral-mid;\n    margin-bottom: 12px;\n    opacity: 0.4;\n  }\n\n  &__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: $body-content-color;\n    margin: 0 0 4px;\n  }\n\n  &__text {\n    font-size: 14px;\n    color: $color-neutral-mid;\n    margin: 0 0 20px;\n  }\n}\n\n// ── Summary Sidebar ──\n.pc-summary {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: 20px;\n\n  &__header {\n    padding: 14px 20px;\n    background: $color-neutral-dark;\n    border-bottom: 1px solid $color-grey-1;\n\n    h3 {\n      font-size: 15px;\n      font-weight: 700;\n      color: #fff;\n      margin: 0;\n      font-family: $font-stack;\n\n      i { margin-right: 6px; opacity: 0.7; }\n    }\n  }\n\n  &__body {\n    padding: 16px 20px;\n  }\n\n  &__item {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 8px 0;\n    gap: 12px;\n  }\n\n  &__item-info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__item-name {\n    display: block;\n    font-size: 13px;\n    font-weight: 500;\n    color: $body-content-color;\n    line-height: 1.3;\n    margin-bottom: 2px;\n  }\n\n  &__item-qty {\n    font-size: 11px;\n    color: $color-neutral-mid;\n  }\n\n  &__item-price {\n    font-size: 13px;\n    font-weight: 600;\n    color: $body-content-color;\n    white-space: nowrap;\n  }\n\n  &__divider {\n    height: 1px;\n    background: $color-grey-1;\n    margin: 8px 0;\n  }\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 0;\n    font-size: 13px;\n    color: $body-content-color;\n\n    &--muted {\n      font-size: 12px;\n      color: $color-neutral-mid;\n    }\n\n    &--total {\n      font-size: 16px;\n      font-weight: 700;\n      color: $body-content-color;\n      padding-top: 8px;\n    }\n  }\n\n  &__amount {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n\n    &--total {\n      font-size: 18px;\n      color: $develop-color;\n    }\n\n    &--muted {\n      font-weight: 400;\n      font-size: 11px;\n      color: $color-neutral-mid;\n      font-style: italic;\n    }\n  }\n\n  &__footer {\n    padding: 16px 20px;\n    border-top: 1px solid $color-grey-1;\n    text-align: center;\n  }\n\n  &__or {\n    font-size: 12px;\n    color: $color-neutral-mid;\n    margin: 8px 0;\n  }\n}\n\n// ── Buttons ──\n.pc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba($develop-color, 0.2);\n\n    &:hover {\n      background: darken($develop-color, 6%);\n      box-shadow: 0 4px 12px rgba($develop-color, 0.3);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-red {\n    background: none;\n    border: 1px solid $color-grey-1;\n    color: $color-neutral-mid;\n    font-size: 12px;\n    padding: 7px 14px;\n\n    &:hover {\n      border-color: $implement-color;\n      color: $implement-color;\n    }\n  }\n\n  &--link {\n    background: none;\n    color: $clarify-color;\n    font-size: 13px;\n\n    &:hover {\n      color: darken($clarify-color, 10%);\n      text-decoration: none;\n    }\n  }\n\n  &--full {\n    width: 100%;\n    padding: 12px;\n    font-size: 15px;\n  }\n}\n\n// ── Coupon Banner (keep existing) ──\n.coupon-banner {\n  margin-bottom: 16px;\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba($develop-color, 0.06), rgba($develop-color, 0.02));\n    border: 1px solid rgba($develop-color, 0.2);\n    border-radius: 8px;\n  }\n\n  &__icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: rgba($develop-color, 0.12);\n    color: $develop-color;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n\n  &__text {\n    flex: 1;\n    font-size: 13px;\n    color: $body-content-color;\n    line-height: 1.4;\n\n    strong {\n      display: block;\n      font-size: 14px;\n      margin-bottom: 2px;\n    }\n  }\n\n  &__code {\n    display: inline-block;\n    padding: 1px 8px;\n    background: #fff;\n    border: 1px dashed rgba($develop-color, 0.4);\n    border-radius: 4px;\n    font-family: monospace;\n    font-size: 13px;\n    font-weight: 700;\n    color: $develop-color;\n    letter-spacing: 0.5px;\n  }\n\n  &__close {\n    width: 24px;\n    height: 24px;\n    border: none;\n    background: transparent;\n    color: $color-neutral-mid;\n    font-size: 12px;\n    cursor: pointer;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: all 0.15s;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.05);\n      color: $body-content-color;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
